/**
 * Base URL for HistoricalService / Footer fetches: `${getApiBaseUrl()}/data/...`.
 * Default `/api` matches nginx `location /api/data/` → Node on 3001.
 *
 * If VITE_API_BASE_URL is a full origin with no path (e.g. https://irinter.net),
 * `/api` is appended so calls hit /api/data/* instead of 404 on /data/*.
 */
export function getApiBaseUrl(): string {
  const raw = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
  if (!raw) return '/api';
  const base = raw.replace(/\/+$/, '');
  try {
    const u = new URL(base);
    if (u.pathname === '/' || u.pathname === '') {
      return `${base}/api`;
    }
  } catch {
    /* relative e.g. /api */
  }
  return base;
}
